import Lab from '../Lab/index.js';
import useInstance from './useInstance.js';
import { useMemo, useEffect } from 'react';
import { Provider as StoreProvider } from './useLab.js';

export default function useAlchemy(config) {
  const instance = useInstance(() => (
    config.isLab ? config : Lab(config)
  ), [config]);

  const { store, init } = instance;

  useEffect(() => void init(), [init]);

  const StoreProviderComponent = useMemo(() => {
    return function StoreProviderComponent({ children }) {
      return (
        <StoreProvider value={ store() }>
          { children }
        </StoreProvider>
      );
    };
  }, [store]);

  StoreProviderComponent.alchemy = instance;
  
  return StoreProviderComponent;
};